export const logger = {
  log: (...params: unknown[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[Analytics]', ...params)
    }
  },

  error: (message: string) => {
    if (process.env.NODE_ENV === 'development') {
      console.error('[Analytics Error]', message)
    }
  },

  assert: (value: unknown, message: string) => {
    if (process.env.NODE_ENV === 'development') {
      console.assert(value, `[Analytics Assert] ${message}`)
    }
  },

  required: (value: unknown, name: string) => {
    if (process.env.NODE_ENV === 'development') {
      if (!value) {
        console.error(`[Analytics Required] ${name} is required but not provided`)
      }
    }
  },
}
